import React from "react";
import { DAM_API_URL } from "config/constants";
import NavigationHeader from "dashboard/containers/NavigationHeader";

import { Helmet } from "react-helmet";
import { connect } from "react-redux";

import { IlloLibrary as AxiosIlloLibrary } from "@axioscode/plus-react-components";

const IlloLibrary = props => {
  return (
    <div className="bg-white">
      <Helmet>
        <title>Illo Library</title>
      </Helmet>
      <div>
        <NavigationHeader />
      </div>
      <div className="max-w-screen-xl mx-auto">
        <AxiosIlloLibrary
          apiUrl={DAM_API_URL}
          token={props.token.accessToken}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  isAuthenticated: state.isAuthenticated,
  token: state.token,
});

export default connect(mapStateToProps)(IlloLibrary);
